import { ref } from 'vue';
import 'bootstrap';
import useSetEnv from '@global/composable/useSetEnv';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';
import useModalStore from '@global/stores/useModalStore';

const { setEnv } = useSetEnv();
const { getSeriesDataAPI, getDataAPI } = useAxiosAPI();
const modalStore = useModalStore();
const { closeModal, openModal } = modalStore;

// 一般賣場
const dialogData = ref({
  isOpen: false,
  allData: {},
  selectedID: '',
  dataLoad: false,
  listName: '',
});
const isMobile = setEnv.myEquipment();

/**
 * @description 展開商品詳細資訊
 * @param {String} id 賣場ID
 */
function openDialog(id, listName = '') {
  dialogData.value.listName = listName;
  getDataAPI({
    params: {
      CustomMarketID: id,
    },
  })
    .then((res) => {
      if (res.data.Code === 200) {
        if (!isMobile) {
          openModal('CartDialog');
        } else {
          dialogData.value.isOpen = true;
        }

        dialogData.value.allData = res.data.Response;
        dialogData.value.selectedID = res.data.Response.ColorID;
        dialogData.value.dataLoad = true;
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

function changeOpen(boolean) {
  if (!isMobile) {
    closeModal();
  } else {
    dialogData.value.isOpen = boolean;
  }
  dialogData.value.dataLoad = boolean;
}

// 系列賣場
const foodDialogData = ref({
  isOpen: false,
  allData: {},
  dataLoad: false,
  listName: '',
});

/**
 * @description 展開商品詳細資訊
 * @param {String} id 賣場ID
 * @param {String} listName GTM 用
 */
function openFoodDialog(id, listName = '') {
  foodDialogData.value.listName = listName;
  getSeriesDataAPI({
    params: {
      MarketID: id,
    },
  })
    .then((res) => {
      if (res.data.Code === 200) {
        if (!isMobile) {
          openModal('FoodDialog');
        } else {
          foodDialogData.value.isOpen = true;
        }

        foodDialogData.value.allData = res.data.Response;
        foodDialogData.value.dataLoad = true;
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

function changeFoodOpen(boolean) {
  foodDialogData.value.isOpen = boolean;
}

// eslint-disable-next-line import/prefer-default-export
function useDialog() {
  return { dialogData, openDialog, changeOpen, foodDialogData, openFoodDialog, changeFoodOpen };
}

export default useDialog;
